import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomTopicMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomTopicMessage = ({ message, className = '' }: RoomTopicMessageProps) => {
  const sender = message.sender;
  const topic = message.content.topic;
  return (
    <div className={`room-topic-message ${className}`} style={{ color: '#6d4c41', padding: '8px 0' }}>
      {sender ? `${sender} 修改了房间话题为「${topic}」` : `房间话题被修改为「${topic}」`}
    </div>
  );
}; 